export const baseTestName = '5-main-page-logos';
export const NO_DEAL_STORIES_AB_TEST = 'ab-test-8-remove-deal-story-2021-07-01';
